module.exports = {
        srcSet: __webpack_public_path__ + "static/media/document-400.da1407c5.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/document-400.da1407c5.webp",width: 400,height: 399}],
        src: __webpack_public_path__ + "static/media/document-400.da1407c5.webp",
        toString: function(){return __webpack_public_path__ + "static/media/document-400.da1407c5.webp"},
        
        width: 400,
        height: 399
      }